import React, { useState } from "react";
import { ProfitDetailsTableProps } from "./types";
import { Grid, Switch } from "@material-ui/core";
import useStyles from "./styles";
import { getCurrencyPositiveOrNegativeColoring } from "../../shared/tableFunctions";
import BarChart from "../../components/BarChart";
import StatTable from "../../components/StatTable";
import { useI18n } from "../../../../hooks/useI18n";

const ProfitDetailsTable = ({
  title,
  profits,
  displayGraphSwitch
}: ProfitDetailsTableProps) => {
  const classes = useStyles();
  const { t } = useI18n();

  const [showGraph, setShowGraph] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowGraph(event.target.checked);
  };

  return (
    <div>
      {displayGraphSwitch ? (
        <Grid
          className={
            showGraph
              ? classes.switchContainer
              : classes.switchContainerAbsolute
          }
          component="label"
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item>{t("common.messages.table")}</Grid>
          <Grid item>
            <Switch
              size={"small"}
              checked={showGraph}
              onChange={handleChange}
              name="graphSwitch"
            />
          </Grid>
          <Grid item>{t("common.messages.chart")}</Grid>
        </Grid>
      ) : (
        <></>
      )}
      {showGraph ? (
        <BarChart
          chartData={{
            labels: profits.map((p: { name: any }) => p.name),
            datasets: [
              {
                label: t("common.tableHeaders.acquisitionCost"),
                rgbColor: { r: 240, g: 155, b: 13 },
                data: profits.map((p: { cost: any }) => p.cost),
                stack: "stack 0"
              },
              {
                label: "Waste",
                rgbColor: { r: 195, g: 88, b: 66 },
                data: profits.map((p: { waste: any }) => p.waste),
                stack: "stack 0"
              },
              {
                label: "Campaign",
                rgbColor: { r: 5, g: 89, b: 141 },
                data: profits.map((p: { campaign: any }) => p.campaign),
                stack: "stack 0"
              },
              {
                label: "Profit (excl. coupons)",
                rgbColor: { r: 31, g: 132, b: 52 },
                data: profits.map((p: { profit: any }) => p.profit),
                stack: "stack 0"
              },
              {
                label: "Sales",
                rgbColor: { r: 0, g: 148, b: 148 },
                data: profits.map((p: { sales: any }) => p.sales),
                stack: "stack 1"
              }
            ]
          }}
          options={{
            scales: {
              x: {
                stacked: true
              },
              y: {
                stacked: true
              }
            }
          }}
          showLegend={true}
          isLoading={false}
        />
      ) : (
        <StatTable
          isLoading={false}
          exportName={`Profit by ${title} statistics`}
          columns={[
            { title: title, field: "name", cellStyle: { padding: "8px" } },
            {
              title: "Sales",
              field: "salesFormatted",
              cellStyle: { padding: "8px" },
              customSort: (a: any, b: any) => {
                return a.sales - b.sales;
              }
            },
            {
              title: t("common.tableHeaders.acquisitionCost"),
              field: "costFormatted",
              cellStyle: { padding: "8px" },
              customSort: (a: any, b: any) => {
                return a.cost - b.cost;
              }
            },
            {
              title: "Waste",
              field: "wasteFormatted",
              cellStyle: { padding: "8px" },
              customSort: (a: any, b: any) => {
                return a.waste - b.waste;
              }
            },
            {
              title: "Campaign",
              field: "campaignFormatted",
              cellStyle: { padding: "8px" },
              customSort: (a: any, b: any) => {
                return a.campaign - b.campaign;
              }
            },
            {
              title: "Profit (excl. coupons)",
              field: "profitFormatted",
              cellStyle: {
                padding: "8px",
                borderLeft: "1px solid #e9e5e2",
                backgroundColor: "rgba(5,89,141, 0.1)"
              },
              customSort: (a: any, b: any) => {
                return a.profit - b.profit;
              },

              render: (rowData: any) =>
                getCurrencyPositiveOrNegativeColoring(rowData.profit)
            }
          ]}
          data={profits}
          dense
        />
      )}
    </div>
  );
};
export default ProfitDetailsTable;
